import React from 'react';
import {graphql} from "gatsby"
import styled from '@emotion/styled';
import {centeredContent, modularScale} from '../design-system/utils';
import PageHeading from "../design-system/typography/page-heading";
import theme from "../design-system/theme";
import Layout from "../components/layout"

export default function Template({data, location}) {
    const {markdownRemark} = data;
    const {frontmatter, html, tableOfContents} = markdownRemark;

    return (
        <Layout location={location} title={frontmatter.title} hideDownload={true}>
            <StyledMarkdownPage>
                <div className="table-of-contents">
                    <div dangerouslySetInnerHTML={{__html: tableOfContents}}/>
                </div>
                <div className="markdown-content">
                    <PageHeading className="markdown-heading">{frontmatter.title}</PageHeading>
                    <div dangerouslySetInnerHTML={{__html: html}}/>
                </div>
            </StyledMarkdownPage>
        </Layout>
    );
}

const StyledMarkdownPage = styled('div')`
	padding-top: 100px;
	padding-bottom: 200px;
	${centeredContent};

    width: 100%;
	@media (min-width: ${theme.breakpoints.desktop}px) {
	    width: 80%;
    }
            
    .markdown-content {
        
	    @media (min-width: ${theme.breakpoints.desktop}px) {
            margin-left: 300px;
	    }
        
	    overflow-wrap: break-word;
	    word-wrap: break-word;   
        word-break: break-word;
	    
	    > div > h1 {
	        padding-top: 20px;
	        padding-bottom: 0px;
	        line-height: ${theme.typography.heading.lineHeight};
            font-weight: ${theme.typography.heading.fontWeight};
            font-size: ${modularScale(4.0)};
            
            @media (min-width: ${theme.breakpoints.tablet}px) {
                font-size: ${modularScale(5.0)};
            }
        }
	    
	    > div > h2 {
	        padding-top: 45px;
	        padding-bottom: 0px;
	        line-height: ${theme.typography.heading.lineHeight};
            font-weight: ${theme.typography.heading.fontWeight};
            font-size: ${modularScale(2.0)};
            
            @media (min-width: ${theme.breakpoints.tablet}px) {
                font-size: ${modularScale(3.0)};
            }
            
            > img {
                position: relative;
                top: 10px;
            } 
        }
        
        > div > h3 {
            padding-left: 0px;
            padding-top: 0px;
	        padding-bottom: 10px;
	        margin-bottom: 0px;
	        line-height: ${theme.typography.heading.lineHeight};
            font-weight: ${theme.typography.heading.fontWeight};
            font-size: ${modularScale(1.5)};
            
            @media (min-width: ${theme.breakpoints.tablet}px) {
                font-size: ${modularScale(2.5)};
            }
        }
        
        > div > h4 {
            padding-left: 20px;
            padding-top: 0px;
	        padding-bottom: 10px;
	        margin-bottom: 0px;
	        line-height: ${theme.typography.heading.lineHeight};
            font-weight: ${theme.typography.heading.fontWeight};
            font-size: ${modularScale(0.8)};
            
            @media (min-width: ${theme.breakpoints.tablet}px) {
                font-size: ${modularScale(1.8)};
            }
        }
        
        > div > h5 {
            padding-top: 20px;
	        padding-bottom: 0px;
	        margin-bottom: 0px;
	        line-height: ${theme.typography.heading.lineHeight};
            font-weight: ${theme.typography.heading.fontWeight};
            font-size: ${modularScale(0.5)};
            
            @media (min-width: ${theme.breakpoints.tablet}px) {
                font-size: ${modularScale(1.0)};
            }
        }
    }
     
    tr, td {
        text-align: left;
    }
        
    table {
        border: none;
        padding: 20px;
        width: 100%;
        border-radius: 20px;
        background-color: #efefef;
    }
    
    pre {
        font-family: ${theme.typography.body.fontFamily.join(', ')};
        font-size: ${modularScale(-0)};
        padding: 20px;
        background-color: #efefef;
        border-radius: 20px;
    }
    
    img {
        /* zoom: 50%; */
        max-width: 100%;
    }

    .markdown-heading {
        padding-bottom: 20px;
        margin: 0;
    }
    
	.markdown-date {
		margin: 0;
		font-size: ${modularScale(1)};
	}
	
	.toc-header {
	    font-weight: ${theme.typography.body.boldFontWeight};
	    font-size: ${modularScale(2.6)};
	}
	
	.table-of-contents {
	
	    display: none;
	    @media (min-width: ${theme.breakpoints.desktop}px) {
		    display: block;
	    }
	
	    width: 260px;
	    box-sizing: border-box;
	    position: fixed;
        top: 160px;
        bottom: 100px;
        padding-bottom: 100px;
        overflow: scroll;

        a {
            color: #000000;
        }
        
        ul {
            list-style-type: none;
            padding-left: 6px;
            padding-bottom: 0px;
        }
        
        li {
            list-style-type: none;
            padding-bottom: 3px;
            
            p {
                margin-bottom: 5px;
            }
        }
        
        div > ul > li > p {
            font-size: ${modularScale(1.1)};
            font-weight: ${theme.typography.body.boldFontWeight};
        }
        
        div > ul > li > ul > li > p {
            font-weight: ${theme.typography.body.boldFontWeight};
        }
	}
`;

export const query = graphql`
  query DocumentationByPath($path: String!, $lang: String!, $date_format: String) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      tableOfContents
      frontmatter {
        date(formatString: $date_format, locale: $lang)
        path
        title
      }
    }
  }`;

// https://www.gatsbyjs.com/plugins/gatsby-transformer-remark/